module.exports = __webpack_public_path__ + "public/1.0.1_009961/img/cancel.45ef4e5f.png";